import * as React from 'react';
import classNames from 'classnames';
import {Text} from '../Text';
import style from './Label.scss';

interface LabelProps {
  label: string;
  id?: string;
  htmlFor?: string;
  ariaHidden?: boolean;
  inheritColor?: boolean;
  className?: string;
}

export function Label({
  label,
  id,
  htmlFor,
  inheritColor = false,
  ariaHidden = false,
  className,
}: LabelProps) {
  return (
    <label
      className={classNames(style.label, className)}
      id={id}
      htmlFor={htmlFor}
      aria-hidden={ariaHidden}
    >
      <Text text={label} inheritSize inheritColor={inheritColor} resetMargin />
    </label>
  );
}
